"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.vaultAddress = exports.voterAddress = exports.voterWeightRecordAddress = exports.registrarAddress = exports.getVsrProgram = exports.VOTER_DISCRIMINATOR = exports.REGISTRAR_DISCRIMINATOR = exports.PDA_SEED_VOTER = exports.PDA_SEED_VOTER_WEIGHT_RECORD = exports.PDA_SEED_REGISTRAR = exports.VOTER_ACCOUNT_NAME = exports.REGISTRAR_ACCOUNT_NAME = exports.VoterStakeRegistryIDL = void 0;
const web3_js_1 = require("@solana/web3.js");
const generated = __importStar(require("../types/voter_stake_registry"));
const utf8_1 = require("@coral-xyz/anchor/dist/cjs/utils/bytes/utf8");
const anchor_1 = require("@coral-xyz/anchor");
const solana_spl_token_modern_1 = require("solana-spl-token-modern");
exports.VoterStakeRegistryIDL = generated.IDL;
exports.REGISTRAR_ACCOUNT_NAME = 'registrar';
exports.VOTER_ACCOUNT_NAME = 'voter';
exports.PDA_SEED_REGISTRAR = 'registrar';
exports.PDA_SEED_VOTER_WEIGHT_RECORD = 'voter-weight-record';
exports.PDA_SEED_VOTER = 'voter';
exports.REGISTRAR_DISCRIMINATOR = Buffer.from([
    193, 202, 205, 51, 78, 168, 150, 128,
]);
exports.VOTER_DISCRIMINATOR = Buffer.from([
    241, 93, 35, 191, 254, 147, 17, 202,
]);
function getVsrProgram({ connection, provider, wallet, opts, programId, }) {
    if (!provider && connection) {
        if (!wallet) {
            throw new Error('wallet is required when provider is not specified to get VoterStakeRegistry program');
        }
        if (wallet instanceof web3_js_1.Keypair) {
            wallet = new anchor_1.Wallet(wallet);
        }
        provider = new anchor_1.AnchorProvider(connection, wallet, opts || { commitment: connection.commitment });
    }
    if (!provider) {
        throw new Error('provider or connection is required to get VoterStakeRegistry program');
    }
    return new anchor_1.Program(exports.VoterStakeRegistryIDL, programId, provider);
}
exports.getVsrProgram = getVsrProgram;
// [realm.key().as_ref(), b"registrar".as_ref(), realm_governing_token_mint.key().as_ref()]
function registrarAddress({ programId, realm, mint, }) {
    return web3_js_1.PublicKey.findProgramAddressSync([realm.toBytes(), (0, utf8_1.encode)(exports.PDA_SEED_REGISTRAR), mint.toBytes()], programId);
}
exports.registrarAddress = registrarAddress;
// [registrar.key().as_ref(), b"voter-weight-record".as_ref(), voter_authority.key().as_ref()]
function voterWeightRecordAddress({ programId, registrar, voterAuthority, }) {
    return web3_js_1.PublicKey.findProgramAddressSync([
        registrar.toBytes(),
        (0, utf8_1.encode)(exports.PDA_SEED_VOTER_WEIGHT_RECORD),
        voterAuthority.toBytes(),
    ], programId);
}
exports.voterWeightRecordAddress = voterWeightRecordAddress;
// [registrar.key().as_ref(), b"voter".as_ref(), voter_authority.key().as_ref()]
function voterAddress({ programId, registrar, voterAuthority, }) {
    return web3_js_1.PublicKey.findProgramAddressSync([registrar.toBytes(), (0, utf8_1.encode)(exports.PDA_SEED_VOTER), voterAuthority.toBytes()], programId);
}
exports.voterAddress = voterAddress;
function vaultAddress({ voter, mint, }) {
    return (0, solana_spl_token_modern_1.getAssociatedTokenAddressSync)(mint, voter, true);
}
exports.vaultAddress = vaultAddress;
//# sourceMappingURL=sdk.js.map